<script>
  import { business, showPopup, loyaltyRules } from "../stores.js";
  import EditLoyaltyItem from "./EditLoyaltyItem.svelte";
  import * as BusinessDAL from "../dal/business-dal";
  import * as BusinessBL from "../bl/business-bl";
  import { querystring, push, pop, location } from "svelte-spa-router";
  import LoadingAnim from "./LoadingAnim.svelte";
  import FaTrashAlt from "svelte-icons/fa/FaTrashAlt.svelte";
  import { fade } from "svelte/transition";
  import FaRegEdit from "svelte-icons/fa/FaRegEdit.svelte";
  import clone from "just-clone";
  import { parse } from "qs";

  export let params;

  let saving = false;

  let itemDraft;

  let mode; //edit or new

  let activeRules;

  $: {
    if ($loyaltyRules)
      activeRules = $loyaltyRules.filter((rule) => rule.active);
    checkQueryString();
  }

  let inactiveRules;
  $: {
    if ($loyaltyRules)
      inactiveRules = $loyaltyRules.filter((rule) => !rule.active);
  }

  function checkQueryString() {
    let sp = new URLSearchParams($querystring);
    if (sp.has("edit") && $loyaltyRules) {
      mode = "edit";
      let ruleId = parse($querystring).edit;
      let rule = $loyaltyRules.find((r) => r.id == ruleId);
      if (rule) {
        itemDraft = clone(rule);
      }
    } else if (sp.has("new")) {
      mode = "new";
      itemDraft = {
        active: true,
        title: "קנה 10 קפה, קבל קפה חינם",
        collectibleCount: 10,
        collectibleItems: [],
        rewardItems: [],
      };
    } else {
      mode = null;
      itemDraft = null;
    }
  }

  querystring.subscribe(() => {
    checkQueryString();
  });

  $: {
    if (!$business || $business.code != params.code) {
      BusinessBL.getBusiness(params.code);
    }
  }

  function newItem() {
    push(`${$location}?new`);
  }

  function editItem(item) {
    itemDraft = clone(item);
    push(`${$location}?edit=${item.id}`);
  }

  // async function deleteItem(item) {
  //   try {
  //     saving = true;
  //     await BusinessDAL.deleteLoyaltyRule($business.code, item);
  //   } catch (err) {
  //     showPopup(err);
  //   } finally {
  //     saving = false;
  //   }
  // }

  $: console.log($loyaltyRules);

</script>

{#if itemDraft}
  <div class="editItemBg" transition:fade={{ duration: 100 }} on:click={pop}>
    <EditLoyaltyItem {mode} {itemDraft} />
  </div>
{/if}

<div class="rules">
  {#if $loyaltyRules}
    {#each activeRules as rule (rule.id)}
      <div class="rule">
        <div
          on:click|stopPropagation={() => {
            editItem(rule);
          }}
          class="titleBtn"
        >
          <FaRegEdit />
        </div>
        <div class="ruleTitle">{rule.title}</div>
      </div>
    {/each}

    {#if inactiveRules.length > 0}
      <h2>כרטיסיות לא פעילות</h2>
      {#each inactiveRules as rule (rule.id)}
        <div class="rule">
          <div
            on:click|stopPropagation={() => {
              editItem(rule);
            }}
            class="titleBtn"
          >
            <FaRegEdit />
          </div>
          <div class="ruleTitle inactive">{rule.title}</div>
        </div>
      {/each}
    {/if}
  {/if}
  <div class="addSectionBtn" on:click={newItem}>מבצע חדש</div>
</div>
{#if saving}
  <div class="saving">
    <LoadingAnim />
  </div>
{/if}

<style>
  h2 {
    margin: 50px 30px 20px 10px;
  }
  .saving {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #0008;
    z-index: 999;
  }

  .addSectionBtn {
    margin-bottom: 120px;
    background: var(--blue1);
    margin: auto;
    margin-bottom: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 24px;
    border-radius: 100px;
    margin-top: 20px;
    padding: 10px;
    width: 100%;
    max-width: 200px;
    direction: ltr;
    cursor: pointer;
  }

  .titleBtn {
    min-width: 24px;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
    padding: 12px;
    cursor: pointer;
    color: #333333;
  }

  .rules {
    direction: rtl;
  }
  .rule {
    direction: rtl;
    padding: 10px 0px 10px 10px;
    color: #2e2e2e;
    position: relative;
    display: flex;
    border-bottom: 3px dotted #bcbcbc;
    user-select: none;
    background: white;
    align-items: center;
  }

  .ruleTitle {
    display: flex;
    justify-content: space-between;
    width: 100%;
    user-select: none;
    font-family: "Rubik";
    font-weight: 500;
    font-size: 18px;
    color: var(--grey1);
  }

  .ruleTitle.inactive {
    color: #bbb;
  }

  .editItemBg {
    position: fixed;
    background: #0004;
    width: 100%;
    height: 100%;
    padding: 10px;
    box-sizing: border-box;
    z-index: 2;
    display: block;
    justify-content: center;
    padding-top: var(--nav-bar-height);
    margin-bottom: 30px;
    top: 0;
    overflow: auto;
  }

</style>
